import {Button, Card, Skeleton, Table} from '@mantine/core'
import {ProjectRow} from './ProjectRow.tsx'
import {IconChevronDown, IconChevronRight, IconPlus} from '@tabler/icons-react'
import {range} from 'lodash'
import {AddProjectModal} from './modals/AddProjectModal.tsx'
import {EditProjectModal} from './modals/EditProjectModal.tsx'
import {useState} from 'react'
import {useProjects} from '../../providers/projects/useProjects.ts'
import type {Project} from '@package/shared'

type Props = {disabled: boolean}

export const ProjectsList = ({disabled: containerDisabled}: Props) => {
  const [showAddForm, setShowAddForm] = useState<boolean>(false)
  const {activeProjects, archivedProjects, loading} = useProjects()
  const [projectToEdit, setProjectToEdit] = useState<Project>()
  const [showArchivedProjects, setShowArchivedProjects] = useState<boolean>(false)

  const disabled = loading || containerDisabled

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
      <Card p={0}>
        <Table>
          <Table.Tbody>
            {activeProjects.map((project) => (
              <ProjectRow key={project.id} project={project} onClick={() => setProjectToEdit(project)} />
            ))}

            {archivedProjects.length > 0 && (
              <Table.Tr>
                <Table.Td colSpan={2}>
                  <Button
                    variant={'transparent'}
                    size={'compact-xs'}
                    onClick={() => setShowArchivedProjects((collapsed) => !collapsed)}
                    leftSection={
                      showArchivedProjects ? <IconChevronDown stroke={1} /> : <IconChevronRight stroke={1} />
                    }
                    fullWidth={false}
                    justify={'left'}
                    p={0}
                    m={0}
                  >
                    {showArchivedProjects ? 'Hide archived projects' : 'Show archived projects'}
                  </Button>
                </Table.Td>
              </Table.Tr>
            )}

            {showArchivedProjects &&
              archivedProjects.map((project) => (
                <ProjectRow key={project.id} project={project} onClick={() => setProjectToEdit(project)} />
              ))}

            {loading &&
              range(0, 3).map((i) => (
                <Table.Tr key={i}>
                  <Table.Td width={25}>
                    <Skeleton h={20} w={20} />
                  </Table.Td>
                  <Table.Td colSpan={2}>
                    <Skeleton h={30} maw={300} />
                  </Table.Td>
                </Table.Tr>
              ))}
          </Table.Tbody>
        </Table>
      </Card>

      <Button
        variant={'subtle'}
        onMouseDown={() => setShowAddForm(true)}
        disabled={disabled}
        leftSection={<IconPlus stroke={1} />}
      >
        Add project
      </Button>

      <AddProjectModal opened={showAddForm} onClose={() => setShowAddForm(false)} />
      <EditProjectModal project={projectToEdit} opened={!!projectToEdit} onClose={() => setProjectToEdit(undefined)} />
    </div>
  )
}
